import apiClient from 'api/base';
import { DraftTask, Task } from 'models/task.model';

export const getTasks = async (): Promise<Task[]> => {
  const { data } = await apiClient.get('/tasks');

  return data;
};

export const getTask = async (id: string): Promise<Task> => {
  const { data } = await apiClient.get(`/tasks/${id}`);

  return data;
};

export const deleteTask = async (id: string): Promise<Task> => {
  const { data } = await apiClient.delete(`/tasks/${id}`);

  return data;
};

export const draftTask = async (
  task: Omit<DraftTask, 'status'>,
): Promise<Task> => {
  const { data } = await apiClient.post('/tasks', { ...task });

  return data;
};

export const updateTask = async (
  id: string,
  task: Omit<DraftTask, 'status'>,
): Promise<Task> => {
  const { data } = await apiClient.put(`/tasks/${id}`, task);

  return data;
};

export const approveTask = async (id: string): Promise<Task> => {
  const { data } = await apiClient.patch(`/tasks/${id}/approve`);

  return data;
};

export const rejectTask = async (id: string): Promise<Task> => {
  const { data } = await apiClient.patch(`/tasks/${id}/reject`);

  return data;
};

export const reviewTask = async (id: string): Promise<Task> => {
  const { data } = await apiClient.patch(`/tasks/${id}/review`);

  return data;
};

export const createTaskAndReview = async (task: Task): Promise<Task> => {
  try {
    const updatedTask = await draftTask({
      title: task.title,
      description: task.description,
      answer: task.answer,
      errorMessage: task.errorMessage,
      validator: task.validator,
      workModels: task.workModels,
    });

    const data = await reviewTask(updatedTask.id);

    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};

export const updateTaskAndReview = async (task: Task): Promise<Task> => {
  try {
    const updatedTask = await updateTask(task.id, {
      title: task.title,
      description: task.description,
      answer: task.answer,
      errorMessage: task.errorMessage,
      validator: task.validator,
      workModels: task.workModels,
    });

    const data = await reviewTask(updatedTask.id);

    return data;
  } catch (error: unknown) {
    return Promise.reject(error);
  }
};
